// src/pages/AddSchoolPage.jsx
import React from "react";
import AddSchoolLayer from "../components/school/AddSchoolLayer";
import MasterLayout from "../masterLayout/MasterLayout";

export const AddSchoolPage = () => {
  return (
    <MasterLayout>
      <AddSchoolLayer />
    </MasterLayout>
  );
};

export default AddSchoolPage;
